import Logo from 'assets/img/logos/premier-tools-logo.png';
import { useIonRouter } from "@ionic/react";
import { PasswordField, SolidButton, TextField } from "components";
import { FirebaseAuth } from "firebase-config"
import { signInWithEmailAndPassword } from "firebase/auth"
import { useAppDispatch, useForm } from "hooks";
import { checkingCredentials, logout } from "store/auth";
import { getEmailErrorMessage, getPasswordErrorMessage, validateEmail, validatePassword } from "utils";
import "styles/Pages/signin.scss"

const formData = {
    email: '',
    password: '',
}

const formValidations = {
    email: [validateEmail, getEmailErrorMessage],
    password: [validatePassword, getPasswordErrorMessage]
}

export const SignInPage = () => {
    const { email, password, emailValid, passwordValid, isFormValid, onInputChange } = useForm(formData, formValidations);

    const dispatch = useAppDispatch();
    const ionRouter = useIonRouter();

    const signInHandler = async () => {
        dispatch(checkingCredentials());

        await signInWithEmailAndPassword(FirebaseAuth, email, password)
            .then(() => {
                ionRouter.push("/menu", "root", "replace");
            })
            .catch(() => {
                dispatch(logout());
            })
    }

    return (
        <div className="container-card-login">
            <div className="card-form">
                <div className='logo'>
                    <img src={Logo} alt='PremierTools' />
                </div>
                <div className="content-card">
                    <div className="w-full flex flex-col items-center gap-4">
                        <p className="font-bold text-large">INICIAR SESIÓN</p>
                        <div className="w-3/5">
                            <TextField
                                name='email'
                                label='Correo Electrónico'
                                value={email}
                                inputMode="email"
                                changeHandler={onInputChange}
                                autoCapitalize="none"
                                isFieldValid={emailValid}
                                errorMessage={emailValid} />
                        </div>
                        <div className="w-3/5">
                            <PasswordField
                                name='password'
                                label='Contraseña'
                                value={password}
                                changeHandler={onInputChange}
                                isFieldValid={passwordValid}
                                errorMessage={passwordValid}  />
                        </div>
                    </div>
                    <div className="actions">
                        <div className="w-3/5">
                            <SolidButton
                                text='Iniciar sesión'
                                backgroundColor='primary'
                                disabled={!isFormValid}
                                onClickHandler={signInHandler} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}